module.exports = __webpack_public_path__ + "static/img/url4.17659013.png";